import * as m from '@/paraglide/messages';
import '@/styles/astro/new-design.css';

type ScrollRowItem = {
  icon: string;
  text: () => string;
  ariaLabel: string;
};

const firstRowItems: Array<ScrollRowItem> = [
  {
    icon: '🚶',
    text: () => m.homepage_listen_in_walk(),
    ariaLabel: 'Listen while walking outdoors',
  },
  {
    icon: '🏋️',
    text: () => m.homepage_listen_in_gym(),
    ariaLabel: 'Listen during gym workouts',
  },
  {
    icon: '🚗',
    text: () => m.homepage_listen_in_car(),
    ariaLabel: 'Listen while driving',
  },
  {
    icon: '🚌',
    text: () => m.homepage_listen_in_bus(),
    ariaLabel: 'Listen during bus commute',
  },
  {
    icon: '🛒',
    text: () => m.homepage_listen_in_grocery(),
    ariaLabel: 'Listen while shopping for groceries',
  },
  {
    icon: '🏫',
    text: () => m.homepage_listen_in_school(),
    ariaLabel: 'Listen at educational institutions',
  },
  {
    icon: '🧹',
    text: () => m.homepage_listen_in_cleaning(),
    ariaLabel: 'Listen while doing household chores',
  },
  {
    icon: '💪',
    text: () => m.homepage_listen_in_exercising(),
    ariaLabel: 'Listen during exercise routines',
  },
];

const secondRowItems: Array<ScrollRowItem> = [
  {
    icon: '🍳',
    text: () => m.homepage_listen_in_dinner(),
    ariaLabel: 'Listen while cooking dinner',
  },
  {
    icon: '🏃',
    text: () => m.homepage_listen_in_jogging(),
    ariaLabel: 'Listen while jogging',
  },
  {
    icon: '🚶',
    text: () => m.homepage_listen_in_commute(),
    ariaLabel: 'Listen during daily commute',
  },
  {
    icon: '📚',
    text: () => m.homepage_listen_in_literature(),
    ariaLabel: 'Listen during literature review',
  },
  {
    icon: '🍽️',
    text: () => m.homepage_listen_in_lunch(),
    ariaLabel: 'Listen during lunch break',
  },
  {
    icon: '👩‍🍳',
    text: () => m.homepage_listen_in_cooking(),
    ariaLabel: 'Listen while preparing meals',
  },
  {
    icon: '✍️',
    text: () => m.homepage_listen_in_writing(),
    ariaLabel: 'Listen while writing academic papers',
  },
  {
    icon: '📝',
    text: () => m.homepage_listen_in_discuss(),
    ariaLabel: 'Listen while preparing for discussions',
  },
];

export function ListenIn() {
  return (
    <div
      className='mb-8 flex w-full flex-col items-center gap-6 sm:px-4'
      itemScope
      itemType='http://schema.org/ItemList'
    >
      <h2
        className='text-center text-2xl font-extrabold'
        id='listen-in-heading'
        itemProp='name'
      >
        {m.homepage_listen_in_heading()}
      </h2>

      <div
        aria-labelledby='listen-in-heading'
        className='flex w-full flex-col gap-3 sm:gap-2'
        role='region'
      >
        <div
          aria-label='Primary listening scenarios'
          className='flex flex-wrap justify-center gap-2 py-2'
          role='list'
        >
          {firstRowItems.map(({ icon, text, ariaLabel }, index) => (
            <div
              aria-label={ariaLabel}
              className='flex cursor-pointer items-center gap-1 rounded-full border border-steel-140 bg-azure-525/5 px-3 py-2 transition-all duration-300 hover:scale-105 hover:border-blue-200 hover:bg-azure-525/10 hover:shadow-xs sm:px-4'
              itemProp='itemListElement'
              itemScope
              itemType='http://schema.org/ListItem'
              key={text()}
              role='listitem'
            >
              <span aria-hidden='true' className='text-lg' role='img'>
                {icon}
              </span>
              <span
                className='font-inter font-medium text-navy-220/50'
                itemProp='name'
              >
                {text()}
              </span>
              <meta content={String(index + 1)} itemProp='position' />
            </div>
          ))}
        </div>

        <div
          aria-label='Additional listening scenarios'
          className='hidden flex-wrap justify-center gap-2 sm:flex'
          role='list'
        >
          {secondRowItems.map(({ icon, text, ariaLabel }, index) => (
            <div
              aria-label={ariaLabel}
              className='flex cursor-pointer items-center gap-1 rounded-full border border-steel-140 bg-azure-525/5 px-3 py-2 transition-all duration-300 hover:scale-105 hover:border-blue-200 hover:bg-azure-525/10 hover:shadow-xs sm:px-4'
              itemProp='itemListElement'
              itemScope
              itemType='http://schema.org/ListItem'
              key={text()}
              role='listitem'
            >
              <span aria-hidden='true' className='text-lg' role='img'>
                {icon}
              </span>
              <span
                className='font-inter font-medium text-navy-220/50'
                itemProp='name'
              >
                {text()}
              </span>
              <meta content={String(index + 9)} itemProp='position' />
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
